import React, { useEffect, useState } from 'react';
import { Flex, Spinner, Heading, useMediaQuery } from '@podiumhq/design-system';

import FullScreenSpinner from 'components/LoadingElements/FullScreenSpinner';

import AnimatedRoundedContentBox from '../../layout/AnimatedRoundedContentBox';

const LOADING_INTERVAL = 2500;

const CreatingBusinessNumber = () => {
  const loadingMessages = [
    'We’re building a consolidated Inbox to rule them all.',
    'We’re creating text templates so you can just hit “Send.”',
    'We’re creating a chat tool for your website.',
    'We’re generating your new, textable Podium number.',
  ];

  const [isSmallerThan650px] = useMediaQuery('(max-width: 650px)');
  const [index, setIndex] = useState(0);

  const changeLoadingText = () => {
    let i = 0;
    const timer = setInterval(() => {
      if (i < 4) setIndex(i + 1);
      else setIndex(0);

      if (++i === 3) clearInterval(timer);
    }, LOADING_INTERVAL);
  };

  useEffect(() => {
    changeLoadingText();
  }, []);

  return (
    <>
      {isSmallerThan650px ? (
        <FullScreenSpinner
          backgroundColor="black.base"
          direction="column"
          position="relative"
          height="100vh"
          spinnerProps={{ size: 'lg', speed: '0.5s', color: 'black.lightest' }}
        >
          <Heading color="silver.lightest" {...headingStyles}>
            {loadingMessages[index]}
          </Heading>
        </FullScreenSpinner>
      ) : (
        <Flex justifyContent="center">
          <AnimatedRoundedContentBox
            animationBoxProps={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
            height="325px"
            margin="18px"
            padding="90px"
          >
            <Spinner size="md" speed="0.5s" />
            <Heading color="black.lighter" {...headingStyles}>
              {loadingMessages[index]}
            </Heading>
          </AnimatedRoundedContentBox>
        </Flex>
      )}
    </>
  );
};

const headingStyles = {
  fontSize: 'xl',
  fontWeight: 'medium',
  margin: '24px',
  textAlign: 'center',
};

export default CreatingBusinessNumber;
